// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { SubMenuSectionFragmentDoc } from './SubMenuSection.fragment.generated';
import { SubMenuEditorialContentFragmentDoc } from './SubMenuEditorialContent.fragment.generated';
export const SubMenuFragmentDoc = gql`
    fragment subMenu on SubMenu {
  __typename
  title
  description
  useLargeFormatItems
  sections {
    ...subMenuSection
  }
  editorialContent {
    ...subMenuEditorialContent
  }
}
    ${SubMenuSectionFragmentDoc}
${SubMenuEditorialContentFragmentDoc}`;